import { render, staticRenderFns } from "./doceree.vue?vue&type=template&id=664ae665&scoped=true&v-once=true"
import script from "./doceree.vue?vue&type=script&lang=js"
export * from "./doceree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ae665",
  null
  
)

export default component.exports